import React, { Component } from 'react';
import {
    FormGroup,
    Col,
    ControlLabel
} from 'react-bootstrap';
import { FControl } from '../common/forms';
var validator = require('validator');
import axios from 'axios';
var Promise = require("bluebird");
import { Warning } from '../common/basic';


module.exports = class FormRow extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.Value ? this.props.Value : '',
            errorMsg: ''
        };

        this.validateEmail = this.validateEmail.bind(this);
    }

    validatePassword(password, doctorID) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.props.status == 'new') {
                resolve(true);
            }
            else {
                var params = { password: password, userID: doctorID };
                axios
                    .get('/data/checkPassword', { params: params})
                    .then(function (data) {
                        if (data.data == false) {
                            _this.setState({ errorMsg: "Password has been used already, choose another." });
                            resolve(false);
                        }
                        else
                            resolve(true);
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data == "No permissions") {
                            window.location.replace("/login");
                        }
                        console.log(error);
                    });
            }
        });
    }

    validateEmail() {
        var _this = this;
        var email = this.state.value;
        return new Promise(function (resolve, reject) {
            var params = { email: email };
            axios
                .get('/data/checkIfEmailExists/', { params: params })
                .then(function (data) {
                    if (data.data == false) {
                        _this.setState({ errorMsg: "Email address already exists" });
                        resolve(false);
                    }
                    else
                        resolve(true);
                })
                .catch(function (error) {

                    console.log(error);
                });
        });
    }

    validateMobile() {
        var _this = this;
        var mobile = this.state.value;
        return new Promise(function (resolve, reject) {
            var params = { mobile: mobile };
            axios
                .get('/data/checkIfMobileExists/', { params: params })
                .then(function (data) {
                    if (data.data == false) {
                        _this.setState({ errorMsg: "Mobile phone already exists" });
                        resolve(false);
                    }
                    else
                        resolve(true);
                })
                .catch(function (error) {
                    console.log(error);
                });

        });
    }


    validate(value) {
        if (!value) {
            value = this.state.value;
        }

        var errorMsg = '';
        if (value != null && this.props.Validators) {
            var validators = this.props.Validators.split(',');
            for (var i = 0; i < validators.length; i++) {

                switch (validators[i]) {
                    case "notEmpty":
                        if (value.trim() == '') {
                            if (errorMsg != '')
                                errorMsg += ', ';
                            errorMsg += "Required field";
                        }
                        break;
                    case "email":
                        if (value != '') {
                            if (!validator.isEmail(value)) {
                                if (errorMsg != '')
                                    errorMsg += ', ';
                                errorMsg += "Email adress is not valid";
                            }
                        }

                        break;
                    case "alpha":
                        if (value != '' && value != null) {
                            var localErr = false;
                            var split = value.trim().split(' ');
                            for (var j = 0; j < split.length; j++) {
                                if (!validator.isAlpha(split[j])) {
                                    localErr = true;
                                }
                            }
                            if (localErr) {
                                if (errorMsg != '')
                                    errorMsg += ', ';
                                errorMsg += 'Must be only letters';
                            }
                        }
                        break;
                    case "numeric":
                        if (value != '') {
                            if (!validator.isNumeric(value)) {
                                if (errorMsg != '')
                                    errorMsg += ', ';
                                errorMsg += 'Must be only numbers';
                            }
                        }
                        break;
                    case "alphanumeric":
                        if (value != '') {
                            if (!validator.isAlphanumeric(value)) {
                                if (errorMsg != '')
                                    errorMsg += ', ';
                                errorMsg += 'Must be only numbers and letters';
                            }
                        }
                        break;
                    case "name":
                        if (value != '') {
                            if (!/^([- _a-zA-Z]*)$/.test(value)) {
                                if (errorMsg != '')
                                    errorMsg += ', ';
                                errorMsg += 'Must be only letters';
                            }
                        }
                        break;
                    case "password":
                        if (!(this.props.status == 'edit' && value == '')) {
                            if (!validator.isLength(value, { min: 8 })) {
                                if (errorMsg != '')
                                    errorMsg += ', ';
                                errorMsg += 'Password Must be longer then 8 chars';
                            }
                            if (!validator.matches(value,
                                /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[#?!@$%^&*-])[A-Za-z\d].{7,}$/, 'i'
                            )) {
                                if (errorMsg != '')
                                    errorMsg += ', ';
                                errorMsg += 'Password Must contain characters and numbers';
                            }
                        }
                        break;

                };


            }
        }
        this.setState({ errorMsg: errorMsg });
        return (errorMsg.length == 0);
    };

    onInputChange(event) {
        var value = event.target.value;
        this.setState({ value: value });
        this.validate(value);

        if (this.props.onChange) {
            this.props.onChange(value);
        }
    };

    changeValue(val) {
        this.setState({ value: val });
    }

    onKeyUp(event) {
        var value = event.target.value;
        this.validate(value);
    }

    render() {
        /*var placeHolder = this.props.placeholder
            ? this.props.placeholder
            : this.props.caption;*/
        var placeHolder = this.props.placeHolder;
        var input;
        var hiddenInput;
        if (this.props.status == 'edit' || this.props.status == 'new') {
            var isDisabled = (this.props.disabled || (this.props.status == 'edit' && this.props.changeable == false)) ? true : false;
            input = <input
                type={this.props.type}
                placeholder={placeHolder}
                id={this.props.id}
                name={this.props.id}
                value={this.state.value}
                disabled={isDisabled}
                onBlur={this.onKeyUp.bind(this)}
                onChange={this.onInputChange.bind(this)} className='form-control' />;

            if (isDisabled) {
                hiddenInput = <input type='hidden' name={this.props.id} value={this.state.value} />;
            }
        }
        else {
            input = <label>{this.state.value}{placeHolder}</label>
        }
        return (
            <FormGroup>
                <Col componentClass={ControlLabel} lg={2}>
                    {this.props.caption}
                </Col>
                <Col lg={10}>
                    {input}{hiddenInput}
                    <Warning />
                    <label className='errorMessage'>{this.state.errorMsg}</label>
                </Col>
            </FormGroup>
        )
    }
};


// WEBPACK FOOTER //
// ./modules/register/FormRow.jsx